<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { Link } from 'svelte-routing';
  import { authFetch } from '../authService';

  let premises = [];
  let currentUser = null;

  authStore.subscribe(val => currentUser = val.user);

  onMount(async () => {
      if(currentUser) {
          const res = await authFetch(getApiUrl(`/premises/user/${currentUser.idTokenClaims.oid}`));
          premises = await res.json();
      }
  });
</script>

<div class="biz-container">
    <h2>My Business Profile</h2>
    <div class="card">
        <h3>My Stores</h3>
        {#if premises.length === 0}
            <p>You haven't claimed any stores yet. <Link to="/claim">Claim one now</Link>.</p>
        {:else}
            <ul>
                {#each premises as p}
                    <li>
                        <strong>{p.name}</strong> <br/>
                        <small>{p.address}</small>
                    </li>
                {/each}
            </ul>
        {/if}
        <div class="actions">
            <Link to="/add" class="btn">Post New Promotion</Link>
        </div>
    </div>
</div>

<style>
    .biz-container { max-width: 800px; margin: 2rem auto; padding: 0 1rem; }
    .card { background: white; padding: 2rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
    ul { list-style: none; padding: 0; }
    li { border-bottom: 1px solid #eee; padding: 1rem 0; }
    .btn { display: inline-block; background: #28a745; color: white; padding: 0.8rem 1.5rem; text-decoration: none; border-radius: 4px; margin-top: 1rem; }
</style>